import React, { Component } from 'react';

import { createStore, applyMiddleware } from 'redux';
import { Provider, connect } from 'react-redux';
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';

import './App.css';
import ChatUI from './components/ChatUI';
import LoginUI from './components/LoginUI';
import ModeratorScreen from './components/ModeratorScreen';
import EndScreen from './components/EndScreen';
import FeedbackForm from './components/FeedbackForm';
import rootReducer from './reducers'
import { fetchMessages, checkUserExists, promptFeedback } from './actions';


const loggerMiddleware = createLogger();

const store = createStore(
    rootReducer,
    applyMiddleware(
        thunkMiddleware,
        loggerMiddleware
    )
);

// Need to keep track of number of current users
const LoginOrChat = connect(
  (state) => ({
      authorized: state.user.authorized,
      role: state.user.role,
      endConversation: state.convo.meta.endConversation,
      promptFeedback: state.convo.meta.promptFeedback
  })
)(({ authorized, role, endConversation, promptFeedback }) => {

  if (authorized) {
      if (promptFeedback) {
          return (<FeedbackForm />);
      }
      if (endConversation) {
          return (<EndScreen />);
      }
      if (role == "moderator") {
        return (<ModeratorScreen />);
      } else if (role == "guest") {
        return (<ChatUI />);
      }
  }else{
      return (<LoginUI />);
  }
});

class App extends Component {
  render() {
      return (
          <Provider store={store}>
             <LoginOrChat />
          </Provider>
      );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js